import Vue from 'vue'
import App from './App.vue'
import {router} from './router/index'
import {appRouter} from './router/router'
import store from "./store" //vuex
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import global from "@/utils/global" //全局方法
import './assets/date-format.js'
import Router from 'vue-router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
Vue.use(Router)
Vue.use(iView);
Vue.use(global);
Vue.config.productionTip = false;

Vue.filter('long2date', function(lt) {
    if (!lt)
        return '';
    if (lt == '' || lt == null || lt < 0) return;
    var date = new Date(lt * 1000);
    return date.dateFormat('Y-m-d');
})
Vue.filter('long2datetime', function(lt) {
    if (!lt) return '';
    var date = new Date(lt * 1000);
    return date.dateFormat('Y-m-d H:i:s');
})
Vue.filter('toFixed', function(lt, nb) {
    if (!lt) return '0.00';
    return lt.toFixed(nb);
})

new Vue({
    store,
    router,
    data: {
        currentPageName: ''
    },
    mounted () {

        // this.currentPageName = this.$route.name;
        // 显示打开的页面的列表
        this.$store.commit('setOpenedList');
        this.$store.commit('initCachepage');
        // 权限菜单过滤相关
        this.$store.commit('updateMenulist');
        // iview-admin检查更新
    
    },
    created () {
        let tagsList = [];
        appRouter.map((item) => {

            if (item.children.length <= 1) {
                tagsList.push(item.children[0]);
            } else {
                tagsList.push(...item.children);
            }
        });
        // debugger;
        this.$store.commit('setTagsList', tagsList);
    },
    render: h => h(App),
}).$mount('#app')


